import script from "./More.vue?vue&type=script&setup=true&lang=js"
export * from "./More.vue?vue&type=script&setup=true&lang=js"

import "./More.vue?vue&type=style&index=0&id=11815e6a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11815e6a"]])

export default __exports__